<template>
    <div class="counter">
        <div class="count">
            {{ count }}/3
        </div>
    </div>
</template>

<script>
    export default {
        name: "Counter.vue",
        props: ['count']
    }
</script>

<style scoped>
    .counter {
        width: 65px;
        height: 65px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4rem;
        background-color: #B71E3F;
        position: relative;
        transform: rotate(-11deg);
        margin: auto;
        margin-bottom: 80px;
    }
    .count {
         color: white;
        font-size: 21px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/Counter.vue